import { render, staticRenderFns } from "./ModalUUID.vue?vue&type=template&id=1f909473&scoped=true&"
import script from "./ModalUUID.vue?vue&type=script&lang=js&"
export * from "./ModalUUID.vue?vue&type=script&lang=js&"
import style0 from "./ModalUUID.vue?vue&type=style&index=0&id=1f909473&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f909473",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tachyon/facade-configurator/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f909473')) {
      api.createRecord('1f909473', component.options)
    } else {
      api.reload('1f909473', component.options)
    }
    module.hot.accept("./ModalUUID.vue?vue&type=template&id=1f909473&scoped=true&", function () {
      api.rerender('1f909473', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/UI/Modal/AdminPage/ModalUUID.vue"
export default component.exports